export const SUMMARY_ENABLED_CONFIG_KEY = 'Newbuilding.CompareAISummary.Enabled';
